import { useFigurePanelId } from './FigurePanelIdProvider';
export default useFigurePanelId; 
